import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useLocation, history, useIntl } from 'umi';
import { useDispatch } from 'dva';
import qs from 'qs';
import dayjs from 'dayjs';
import { Box } from '@material-ui/core';
import { download } from '@/utils/downloadUtil';
import SearchCondition from './components/search_condition/index';
import AnalysisResult from './components/analysis_result/index';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const intl = useIntl();
  // eslint-disable-next-line no-unused-vars
  const { formatMessage } = intl;
  const searchRef = useRef();
  const downloadRef = useRef();
  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');
  const { query, pathname } = location;
  const {
    signUpDateEnd = dayjs().format('YYYY-MM-DD'),
    signUpDateStart = dayjs().format('YYYY-MM-DD'),
    registerStore,
    isSearch = 'true',
    pageNum = '1',
    pageSize = '10',
  } = query;

  const [sortField, setSortField] = useState('salesPaid');
  const [sort, setSort] = useState(true);
  const [isSearchBtn, setIsSearchBtn] = useState(false);
  const registerStoreArray = registerStore
    ? JSON.stringify(registerStore?.split('-'))
    : '';

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearchBtn(true);
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        ...newParam,
        time: timestamp,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 获取列表
  const fetchSalesList = useCallback(() => {
    if (isSearch === 'true') {
      let startTime = signUpDateStart;
      let endTime = signUpDateEnd;
      if (signUpDateStart) {
        startTime = dayjs(signUpDateStart).format('YYYY-MM-DD');
      }
      if (signUpDateEnd) {
        endTime = dayjs(signUpDateEnd).format('YYYY-MM-DD');
      }
      const values = {
        endTime: endTime,
        startTime: startTime,
        sort: sort ? 'DESC' : 'ASC',
        sortField,
        store: registerStoreArray ? JSON.parse(registerStoreArray) : null,
        pageNum,
        pageSize,
      };
      if (isSearchBtn) {
        window.NE_DAWN.trigger(searchRef.current, {
          event: '_ec', // 事件名
          params: { ...values }, // 事件公参
        });
      }
      setIsSearchBtn(false);
      dispatch({
        type: 'analysis/getOrderSalesList',
        payload: {
          values,
        },
      });
    }
  }, [
    isSearch,
    signUpDateStart,
    signUpDateEnd,
    dispatch,
    sort,
    sortField,
    registerStoreArray,
    pageNum,
    pageSize,
    // isSearchBtn,
  ]);

  useEffect(() => {
    fetchSalesList();
  }, [fetchSalesList]);

  const handleClickExport = () => {
    const values = {
      pageSize: pageSize,
      pageNum: pageNum,
      sort: sort ? 'DESC' : 'ASC',
      sortField: sortField,
      startTime: signUpDateStart,
      endTime: signUpDateEnd,
      store: registerStoreArray ? JSON.parse(registerStoreArray) : null,
    };
    window.NE_DAWN.trigger(downloadRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });
    download('/member-report/downloadOrderSalesDetail', values);
  };

  return (
    <>
      <Box
        data-log={JSON.stringify({
          oid: 'page_offline_store_customer_analysis_details',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <SearchCondition
          query={query}
          handleSearch={(par) => handleSearch(par)}
          searchRef={searchRef}
          restClick={handleRestClick}
        ></SearchCondition>
        <AnalysisResult
          downloadRef={downloadRef}
          setPageData={handlePageChange}
          pagination={{
            pageNum,
            pageSize,
          }}
          setSortField={setSortField}
          setSort={setSort}
          sortField={sortField}
          handleClickExport={() => handleClickExport()}
        ></AnalysisResult>
      </Box>
    </>
  );
};
